import axios from 'axios';
import toast from 'utils/toast';

// API 기본 URL 설정
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.stpeters.co.kr';

// 앱 베이스 URL (라우터용)
const APP_BASE_URL = import.meta.env.VITE_APP_BASE_NAME || '';

// 에러 메시지 맵핑
const ERROR_MESSAGES = {
  400: '잘못된 요청입니다.',
  401: '인증이 필요합니다. 다시 로그인해주세요.',
  403: '접근 권한이 없습니다.',
  404: '요청한 리소스를 찾을 수 없습니다.',
  409: '이미 존재하는 데이터입니다.',
  422: '입력 데이터를 확인해주세요.',
  500: '서버 오류가 발생했습니다.',
  502: '서버에 연결할 수 없습니다.',
  503: '서비스를 일시적으로 사용할 수 없습니다.'
};

// axios 인스턴스 생성
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 요청 인터셉터
axiosInstance.interceptors.request.use(
  (config) => {
    // localStorage에서 토큰 가져오기
    const token = localStorage.getItem('accessToken');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    toast.error('요청을 처리할 수 없습니다.');
    return Promise.reject(error);
  }
);

// 응답 인터셉터
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { response, config } = error;
    
    // 에러 토스트 표시 안 함 옵션 (개별 처리가 필요한 경우)
    const skipToast = config?.skipErrorToast;
    
    if (response) {
      const { status, data } = response;
      
      // 서버에서 보내준 에러 메시지가 있으면 사용, 없으면 기본 메시지 사용
      const serverMessage = data?.message || data?.error;
      const defaultMessage = ERROR_MESSAGES[status] || '오류가 발생했습니다.';
      const errorMessage = serverMessage || defaultMessage;
      
      switch (status) {
        case 401:
          // 인증 실패 - 로그인 페이지로 리다이렉트
          localStorage.removeItem('accessToken');
          localStorage.removeItem('user');
          // 로그인 페이지에서 발생한 401은 토스트만 표시
          if (!window.location.pathname.includes('/login')) {
            if (!skipToast) toast.error(errorMessage);
          window.location.href = `${APP_BASE_URL}/login`;
          } else {
            if (!skipToast) toast.error(errorMessage);
          }
          break;
        default:
          if (!skipToast) toast.error(errorMessage);
      }
    } else if (error.code === 'ECONNABORTED') {
      // 타임아웃
      if (!skipToast) toast.error('요청 시간이 초과되었습니다.');
    } else {
      // 네트워크 오류
      if (!skipToast) toast.error('네트워크 연결을 확인해주세요.');
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;
